export const SUBJECT_LABELS = {
  math: 'Math',
  reading: 'Reading',
  science: 'Science',
  socialStudies: 'Social Studies',
  writing: 'Writing',
  algebraOne: 'Algebra I',
  biology: 'Biology',
  englishOne: 'English I',
  englishTwo: 'English II',
  usHistory: 'US History',
};

export const ID_FIELDS = [
  { key: 'studentId', label: 'STUDENT-ID (state ID)' },
  { key: 'localId', label: 'Local ID' },
  { key: 'tsdsId', label: 'TSDS Unique ID' },
];

export const IGNORE = '__ignore__';
export const UNSET = '';

export const MISSING_REASONS = {
  absent: 'Not in ClassLink',
  inactive: 'Inactive in ClassLink',
  tobedeleted: 'Marked for deletion in ClassLink',
};

export const getCurrentRosterYear = () => {
  const now = new Date();
  return now.getMonth() < 6 ? now.getFullYear() - 1 : now.getFullYear();
};

export const formatWhen = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString();
};

export const formatDuration = (ms) => {
  if (ms == null) return '';
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}m ${s % 60}s`;
};
